var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-full col-span-full"
  }, [_c('div', {
    staticClass: "flex flex-col relative"
  }, [_c('p', {
    staticClass: "text-sm text-gray-600 font-normal truncate mb-2",
    style: _vm.inherits ? 'color: inherit; font-size: inherit; font-weight: inherit;' : ''
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _vm.required ? _c('span', {
    staticClass: "text-pink-600 ml-1"
  }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('div', {
    staticClass: "flex flex-row md:flex-col w-full bg-white border rounded-md border-opacity-50 focus:border-indigo-300 focus:outline-none focus:shadow-outline-indigo text-sm sm:leading-5 appearance-none placeholder-gray-600 transition duration-150 ease-in-out",
    class: _vm.editorClass,
    attrs: {
      "id": "editor-container"
    }
  }, [_c('div', {
    staticClass: "flex flex-col md:flex-row space-x-2 items-center justify-evenly bg-indigo-300 bg-opacity-50 p-2 border-b rounded-md border-indigo-600"
  }, _vm._l(_vm.editorActions, function (action) {
    return _c('button', {
      key: action,
      staticClass: "min-h-10 bg-transparent rounded-md cursor-pointer hover:scale-110 transform transition-all duration-300 p-2 capitalize",
      class: {
        'bg-indigo-600 text-gray-100': _vm.editor && _vm.actionIsActive(action)
      },
      attrs: {
        "name": action
      },
      on: {
        "click": function ($event) {
          return _vm.handleAction(action);
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.actionName(action)) + "\n        ")]);
  }), 0), _vm._v(" "), _c('editor-content', {
    staticClass: "flex-grow",
    attrs: {
      "id": "editor",
      "editor": _vm.editor
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute mb-4 right-0 inset-y-0 pt-10 pr-6 flex items-center cursor-pointer"
  }, [_c('SpeechToText', {
    on: {
      "result": function (result) {
        return _vm.updateMutable(result);
      },
      "startRecognition": _vm.startRecognition,
      "stopRecognition": _vm.stopRecognition
    }
  })], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }